<template>
	<div class="container pdb-26 pdt-6">
		<NoData v-if="isNoData"></NoData>
		<div v-if="campaignData && campaignData.locationValue == null" class="mgt-30 mgb-30">
			<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank" class="d-block">
				<img :src="campaignData.image" :alt="campaignData.dynamicLink.name" class="b-radius4 list-banner-img">
			</a>
			<a v-else href="javascript:void(0)" style="cursor:none">
				<img :src="campaignData.image" alt="" class="b-radius4">
			</a>
		</div>
		<template v-for="(degree, index) in listData"  >
			<div v-if="campaignData && parseInt(campaignData.locationValue) === index+1"  class="mgb-24" :key="index" >
				<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink?campaignData.dynamicLink.shortLink:''" target="_blank" class="d-block">
					<img :src="campaignData.image" :alt="campaignData.dynamicLink.name" class="b-radius4 list-banner-img">
				</a>
				<a v-else href="javascript:void(0)" style="cursor:none">
					<img :src="campaignData.image" class="b-radius4">
				</a>

			</div>
			<CardItem2 :degree="degree"  :key="'card'+index" ></CardItem2>

		</template>   
		 <infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
			<div slot="no-more" class="t-color-white">No more data</div>
			<div slot="no-results" class="mgt-16"></div>
		</infinite-loading>
	</div>

</template>

<script>
// Components/Mixin/Extend/API 선언
/**
 * 신규/인기 차수 리스트 컴포넌트(new/popular degree list Component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'
import campaignApi from '@/api/campaignApi.js'
import CardItem2 from '@/components/degree/list/CardItem2.vue'
import NoData from '@/components/common/NoDataDegree.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
	props: ['listType'],
	components: {
		CardItem2, NoData,InfiniteLoading
	},
	
	data() {
		return {
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			isNoData: false,
			campaignData: null
		}
	},
	watch:{
		$route(to, from){
			this.initData();
			//console.log('Degreee=>')
		}
	},
	mounted() {
		this.initData()
	},
	
	methods: {
		// 목록 데이터 호출(call api list data)
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1;
		},
		fetchData($state) {
			
			let responseData = null
			let userIds = null
			let params = this.setParams()
				userIds = localStorage.getItem("token")
			if(this.listType !== 'ListRecommened') {
				if (this.totalPages >= this.currentPage) {
					degreeApi.learnOnlineList(params).then((response) => {
						responseData = response.data.data
						this.listData = this.listData.concat(responseData.content)
						this.currentPage++
						this.totalPages = responseData.totalPages
						// if (responseData.content.length) {
						//     $state.loaded()
						//     this.linearProgress = false
						// }else {
						//     $state.complete()
						// }
						
						if (!this.listData.length) {
						    this.isNoData = true
						
						}
						$state.complete()
						
					}).catch((err) => {
						
					})
				}else {
					$state.complete()
				}       
				let locationType = this.listType === 'ListNew' ? 'NEW_DEGREE' : 'POPULAR_DEGREE'
					campaignApi.campaign({locationType: locationType}).then((response) => {
					this.campaignData = response.data.data
				}).catch((err) => {})
			} else {
				let params = this.setRecomendParams()
				if (this.totalPages >= this.currentPage) {
					degreeApi.fetchRecommendedList(params).then((response) => {
						responseData = response.data.data

						this.listData = this.listData.concat(responseData.content)
						this.currentPage++
						this.totalPages = responseData.totalPages

						if (responseData.content.length) {
							$state.loaded()
							this.linearProgress = false
						}else {
							$state.complete()
						}

						if (!this.listData.length) {
							this.isNoData = true
						}
						
					}).catch((err) => {
						
					})
				}else {
					$state.complete()
				}

			}

		},

		// 파라미터 설정(set parameter)
		setParams() {
			//console.log('SetParmsUserId',localStorage.getItem("token"))
			if(localStorage.getItem("token") !=null) {
				const params = {
					name:'',
					page: this.currentPage,
					size: 10,
					sort: this.listType === 'ListNew' ? 'group,desc' : 'learnerCount,desc'
				}
				return params
			} else {
				const params = {
					page: this.currentPage,
					size: 10,
					sort: this.listType === 'ListNew' ? 'id,desc' : 'learnerCount,desc'
				}
				return params
			}
			
			
		},
		setRecomendParams() {
			const recParams = {
				page: this.currentPage,
				size: 10,
				sort: 'groupId,desc'
			}
			return recParams
		}   
			
	},

}
</script>